import { TpaWidgetTypes } from '@wix/adi-core-types';
export var isTpaWidgetType = function (type) { return !!TpaWidgetTypes[type]; };
//# sourceMappingURL=index.js.map